import { createActionDuck } from "../helpers/action";
import { createUseFetch } from "../helpers/fetchHooks";
import createItemFetcher from "../helpers/item";
import { createNotificationOnCreateEpic, createNotificationOnCreateErrorEpic, } from "./updateNotification";
export const archiveFoldersFetcher = createItemFetcher(() => "/api/v1/archive/explorer", "ARCHIVE_FOLDERS", () => "archive_folders");
export const useArchiveFoldersFetcher = createUseFetch(archiveFoldersFetcher, (state) => state.archiveFiles.archiveListFolders);
export const getArchiveData = (data) => {
    var _a;
    if ((_a = data === null || data === void 0 ? void 0 : data.collection) === null || _a === void 0 ? void 0 : _a.items) {
        return data.collection.items.map((el) => el);
    }
    else {
        return [];
    }
};
export const getFileList = (data) => {
    var _a, _b;
    if ((_a = data === null || data === void 0 ? void 0 : data.archiveElement) === null || _a === void 0 ? void 0 : _a.records) {
        return (_b = data === null || data === void 0 ? void 0 : data.archiveElement) === null || _b === void 0 ? void 0 : _b.records.map((el) => el);
    }
    else {
        return [];
    }
};
const archivedFiles = (archiveURL) => {
    return `/api/v1/archive/explorer/label?archiveUrl=${archiveURL}`;
};
const archivedId = (archiveURL) => {
    return `${archiveURL}`;
};
export const archivedFilesFetcher = createItemFetcher(archivedFiles, "ARCHIVED_FILES", archivedId);
export const useArchivedFilesFetcher = createUseFetch(archivedFilesFetcher, (state) => state.archiveFiles.archivedFiles, false);
export const computeArchiveFilePost = (config) => {
    const { scenario, workspace, mode, program } = config;
    const url = `/api/v1/archive/${scenario}/${workspace}/${program}/${mode}/archive-panel`;
    return {
        method: "POST",
        url,
    };
};
const computeItemId = (config) => {
    const { scenario, workspace } = config;
    return `${scenario}_${workspace}_archive`;
};
export const archiveFilePostDuck = createActionDuck("FILE_ARCHIVE", computeArchiveFilePost, computeItemId);
archiveFilePostDuck.middleware.push(createNotificationOnCreateEpic(archiveFilePostDuck.ActionKeys), createNotificationOnCreateErrorEpic(archiveFilePostDuck.ActionKeys));
const archivedEbroFiles = (archiveURL) => {
    return `/api/v1/ebro?fileName=${archiveURL}`;
};
export const archivedFilesEbroFetcher = createItemFetcher(archivedEbroFiles, "ARCHIVED_EBRO_FILES", archivedId);
export const useArchivedEbroFetcher = createUseFetch(archivedFilesEbroFetcher, (state) => state.archiveFiles.archivedEbro, false);
//# sourceMappingURL=index.js.map